import store from '@/store';
import { Cache } from 'aws-amplify';
import { executeApi } from '@/assets/js/aws/appsync';
import { usersByLoginID } from '@/graphql/queries';
import { AUTH_EXPIRATION_DAYS } from '@/assets/js/const';
import { addLog } from '@/assets/js/logger';
import { messageKeys } from '@/assets/js/logger/logMessages';
/**
 * Amplify Cacheへユーザー情報（担当者マスタ）をセット
 * @param {String} loginId user.usernameの値
 * @return セットできた場合：true、セットできなかった場合：false
 */
export async function setUserData(loginId) {
  // console.log(`setUserData`);
  // 検索条件
  // let dummyUser = 'dummyuser';
  // console.log(loginId);
  // let condition = { LoginID: dummyUser, filter: { IsDeleted: { eq: 0 } } };
  let condition = { LoginID: loginId, filter: { IsDeleted: { eq: 0 } } };
  const functionName = 'setUserData';
  let existsFlag = false;
  // let test = 'test';

  do {
    let result = null;
    try {
      result = await executeApi(usersByLoginID, condition);
      // result = await executeApi(test, condition);
      await addLog({
        messageKey: messageKeys.I1003,
        component: 'cache.js',
        func: functionName,
        param: JSON.stringify({ method: 'executeApi1', result: result, condition: condition }),
      });
    } catch (error) {
      await addLog({
        messageKey: messageKeys.E3006,
        func: functionName,
        component: 'cache.js',
        param: JSON.stringify({ method: 'executeApi2', query: usersByLoginID, condition: condition }),
        errorObject: error,
      });
      // アラート表示
      console.error(
        'ERROR : error = ' +
          'component:cache.js' +
          '/' +
          'functionName:' +
          functionName +
          JSON.stringify({ method: 'executeApi', query: 'usersByLoginID', condition: condition }) +
          JSON.stringify(error)
      );
      return existsFlag;
    }
    if (result.errors) {
      //クエリ処理がエラー処理
      await addLog({
        messageKey: messageKeys.E3006,
        func: functionName,
        component: 'cache.js',
        param: JSON.stringify({ method: 'executeApi3', query: usersByLoginID, condition: condition }),
        errorObject: result.errors,
      });
      // アラート表示
      console.error(
        'ERROR : error = ' +
          'cache.js' +
          '/' +
          functionName +
          JSON.stringify({ method: 'executeApi', query: 'usersByLoginID', condition: condition }) +
          JSON.stringify(result.errors)
      );
      return existsFlag;
    } else {
      if (result.data.usersByLoginID.items.length >= 1) {
        // データを取得できた場合
        await addLog({
          messageKey: messageKeys.I1003,
          func: functionName,
          component: 'cache.js',
          param: { api: 'result.data.usersByLoginID.items.length', length: result.data.usersByLoginID.items.length },
        });
        const userData = result.data.usersByLoginID.items[0];
        // 取得結果を格納
        // console.info('result.data.usersByLoginID', userData);

        store.commit('setStateUser', userData);

        let date = new Date();
        // const.jsで定義した保持日数をセット
        date.setDate(date.getDate() + AUTH_EXPIRATION_DAYS);
        Cache.setItem('user', userData, { expires: date.getTime() });
        existsFlag = true;
        break;
      }
      condition.nextToken = result.data.usersByLoginID.nextToken;
    }
  } while (condition.nextToken);
  return existsFlag;
}
